<template>
  <div class="top">

    <div class="top-title" >
      <div >
        <div>
          <img src="~@/assets/img/logo.png" style="height: 65px;width: 75px;margin-right: 20px"/>
        </div>
        <div>
          湖南省衡阳汽车运输集团有限公司
        </div>
      </div>

      <!--<div>-->
        <!--<div>-->
          <!--<div><img src="~@/assets/img/phone.png"/></div>-->
          <!--<div>{{'　咨询热线∶0734-8856338'}}</div>-->
        <!--</div>-->

        <!--<div @click="viewQcode()">-->
          <!--<div><img src="~@/assets/img/weixin.png"/></div>-->
          <!--&lt;!&ndash;  <span>{{'｜收藏本站'}}</span>&ndash;&gt;-->
          <!--<div><span style="user-select: none;">{{'　微信公众号购票'}}</span></div>-->
        <!--</div>-->
      <!--</div>-->


      <div @click="viewQcode()" style="justify-content: flex-end;">
        <div><img src="~@/assets/img/weixin.png"/></div>
        <!--  <span>{{'｜收藏本站'}}</span>-->
        <div><span style="user-select: none;">{{'　微信公众号购票'}}</span></div>
      </div>

    </div>
    <div class="v-modal" style="z-index: 3002;opacity: 0.85;" v-if="rcode">
      <div class="qrcodeHome" @click="viewQcode()">
        <div class="close" ></div>
        <div>
          <div>
            <div>
              <img src="~@/assets/img/weixin.jpg" width="250px">
            </div>
            <div style="color: white; user-select: none;">
              请关注衡汽集团公众号(微信扫码)
            </div>
          </div>
          <div>
          </div>
        </div>
      </div>
    </div>
    <div class="top-nav" style=" width: 1230px;">

      <el-menu  class="el-menu-demo" mode="horizontal" >
        <el-menu-item index="1" @click="open('home',0)"><span class="main-top-menu"  >首页</span></el-menu-item>
        <el-submenu index="2">
          <template slot="title"><span class="main-top-menu" @click="open('info',1)" >集团概况</span></template>
          <el-menu-item index="2-1" @click="open('info',1)" >集团介绍</el-menu-item>
          <el-menu-item index="2-2" @click="open('info',2)" >组织机构</el-menu-item>
          <el-menu-item index="2-3" @click="open('info',3)" >企业荣誉</el-menu-item>
        </el-submenu>
        <el-submenu index="3">
        <template slot="title"><span class="main-top-menu" @click="open('new',1)"  >新闻中心</span></template>
        <el-menu-item index="3-1" @click="open('new',1)">企业要闻</el-menu-item>
        <el-menu-item index="3-2" @click="open('new',2)">媒体报道</el-menu-item>
        <el-menu-item index="3-3" @click="open('new',3)">视频展播</el-menu-item>
        <el-menu-item index="3-3" @click="open('new',4)">刊物阅览</el-menu-item>
      </el-submenu>
        <el-submenu index="4">
          <template slot="title" ><span class="main-top-menu"  @click="open('industrial',1)"  >产业布局</span></template>
          <el-menu-item index="4-1" @click="open('industrial',1)">客运业务</el-menu-item>
          <el-menu-item index="4-2" @click="open('industrial',2)">公交业务</el-menu-item>
          <el-menu-item index="4-3" @click="open('industrial',3)">货运业务</el-menu-item>
          <el-menu-item index="4-3" @click="open('industrial',4)">旅游业务</el-menu-item>
          <el-menu-item index="4-3" @click="open('industrial',5)">维修业务</el-menu-item>
         </el-submenu>
        <el-submenu index="5">
          <template slot="title"><span class="main-top-menu" @click="open('party',1)">党建专栏</span></template>
          <el-menu-item index="5-1" @click="open('party',1)">品牌党建</el-menu-item>
          <el-menu-item index="5-2" @click="open('party',2)">纪检监督</el-menu-item>
          <el-menu-item index="5-3" @click="open('party',3)">工会园地</el-menu-item>
          <el-menu-item index="5-3" @click="open('party',4)">信访工作</el-menu-item>
          <el-menu-item index="5-3" @click="open('party',5)">党史学习</el-menu-item>
        </el-submenu>
        <el-menu-item index="6" @click="open('recruit',1)"><span class="main-top-menu">人才招聘</span></el-menu-item>
      <el-submenu index="7">
          <template slot="title"><span class="main-top-menu">在线办公</span></template>
           <el-menu-item index="7-2" @click="wOpen('https://mp.yichang365.com/enterprise-vue/#/login')">安全系统</el-menu-item>
          <el-menu-item index="7-3" @click="wOpen('http://oa.gongchuang.net:81/oa')">办公系统</el-menu-item>
        <el-submenu index="7-4">
          <template slot="title">监控系统</template>
          <el-menu-item index="7-4-1" @click="wOpen('https://v.safetyservice.cn:64043/webapp')">省两客智能平台</el-menu-item>
          <el-menu-item index="7-4-2" @click="wOpen('http://175.6.82.151:8088/CGO8/')">国脉智慧云平台</el-menu-item>
          <el-menu-item index="7-4-3" @click="wOpen('http://clw.bdseg.com/')">赛格监控平台</el-menu-item>
        </el-submenu>
         </el-submenu>
        <el-menu-item index="8" @click="viewQcode()"><span class="main-top-menu"  >客服中心</span></el-menu-item>
     <!--   <el-submenu index="8">
          <template slot="title"><span class="main-top-menu">客服中心</span></template>
          <el-menu-item index="8-1">联系我们</el-menu-item>
          <el-menu-item index="8-2">在线服务</el-menu-item>
          <el-menu-item index="8-3">投诉受理</el-menu-item>
        </el-submenu>-->
      </el-menu>

    <!--  <div class="top-menu">
        <div @click="open('home',0)" :style="openTap == '/'  ? 'color:red;text-decoration:underline':''"><span style="margin-left: 40px">首页</span></div>
         <div @click="open('new-2',2)" :style="openTap == '/new-2'  ? 'color:red;text-decoration:underline':''">新闻动态</div>
        <div @click="open('new-3',3)" :style="openTap == '/new-3'  ? 'color:red;text-decoration:underline':''">党建专栏</div>
        <div @click="open('new-1',1)" :style="openTap == '/new-1'  ? 'color:red;text-decoration:underline':''">公告栏目</div>
        <div @click="open('new-4',4)" :style="openTap == '/new-4'  ? 'color:red;text-decoration:underline':''">企业文化</div>
      </div>-->
    </div>
  </div>
</template>

<script>
    export default {
        name: "main-top",
      data () {
        return {
          openTap : 0,
          rcode:false
        }
        },
      mounted: function () {
       //this.openTap = this.$route.path
      },
        methods: {
          open(name,openTap){
            //this.$parent.open(name)
            this.$router.push({
              name: name,
              query:{
                id : openTap
              }
            })
            //this.openTap = this.$route.path
          },
          wOpen(url){
            window.open(url)
          },
          viewQcode(){
            this.rcode = !this.rcode
          },
        }
    }
</script>

<style scoped>
  .top{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  .top-list{

  }
  .top > div{
    width: 100%;
  }
  .top-title{
    width: 100%;
    background-color: #f2f4f8;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 5px 0px;
  }
  .top-title > div:nth-child(1){
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 8px 20px;
    font-size: 26px;
    font-weight: 700;
    letter-spacing: 2px;
   }
  .top-title > div:nth-child(2){
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 0px 20px;
  }
  .top-nav{
    margin: 30px 0px;
    width: 100%;
    display: flex;
    flex-direction: row;
     align-items: center;
    font-size: 23px;
     justify-content: flex-start;

  }
  .top-nav > div:nth-child(1){
    width: calc(100% - 980px);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-weight: 600;
   }
  .top-menu {
    user-select: none;
    width: 800px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .top-menu >div{
    flex: 1;
  }
  .top-menu > div:hover{
    text-decoration:underline;
    /*border-bottom: 1px solid red;padding-bottom: 5px;*/
    color: red;
  }


  .close {
    position: absolute;
    width: 40px;
    height: 40px;
    right: 20px;
    top: 20px;
    z-index: -5000;
  }

  .close::before,
  .close::after {
    position: absolute;
    content: ' ';
    background-color: white;
    left: 20px;
    width: 5px;
    height: 40px;
  }

  .close::before {
    transform: rotate(45deg);
  }

  .close::after {
    transform: rotate(-45deg);
  }

  .qrcodeHome{
    display: flex;
    flex-direction: row;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
  .qrcodeHome > div{
    padding: 0px 0px 50px 0px;
    margin: 100px;
  }
  .qrcodeHome > div > div:nth-child(1){
    display: flex;
    flex-direction: column;
    align-items: center;
  }











  .el-menu.el-menu--horizontal {
    border-bottom: solid 0px #e6e6e6;
  }
  .main-top-menu{
    font-size: 23px !important;
    color: black;
  }

</style>



// WEBPACK FOOTER //
// src/views/main-top.vue